import { useMemo } from 'react';
import { FinancialsDto, SegmentGroup } from '../../services/dtos/financials/financialsDto';
import { toSegmentGroups } from '../../services/financials/financials.service';

export default (financialsDto?: FinancialsDto): SegmentGroup[] => {
  return useMemo((): SegmentGroup[] => {
    return financialsDto ? toSegmentGroups(financialsDto) : [];
  }, [financialsDto]);
};
